import axios from 'axios'
import TokenService from './tokenService'

const TicketService = {
  getAll: async () => {
    try {
      const token = TokenService.getToken()
      const res = await axios.get('https://app.yanibasimdakaratay.com/api/genclik-merkezi-sinema-salonu', {
        headers: {
          Authorization: token,
        },
      })
      const result = res.data
      if (result.success) {
        return result.data
      }
    } catch (error) {
      return null
    }
  },
  save: async (form) => {
    try {
      const token = TokenService.getToken()
      const res = await axios.post('https://app.yanibasimdakaratay.com/api/genclik-merkezi-sinema-salonu', form, {
        headers: {
          Authorization: token,
        },
      })

      return res.data
    } catch (error) {
      // Laravel validation hataları (422)
      if (error.response && error.response.status === 422) {
        return { errors: error.response.data.errors }
      }

      // Kayıt bulunamadı (404)
      if (error.response && error.response.status === 404) {
        return { error: 'Kayıt bulunamadı.' }
      }

      // Bad Request (400 vs.)
      if (error.response && error.response.status === 400) {
        return { error: error.response.data.message }
      }

      // Yetki hatası (403 vs.)
      if (error.response && error.response.status === 403) {
        return { error: 'Bu işlem için izniniz yok.' }
      }

      // Sunucu hatası (500)
      if (error.response && error.response.status === 500) {
        return { error: 'Sunucu hatası, daha sonra tekrar deneyin.' }
      }

      // Axios vs. bağlantı hatası
      return { error: 'Bilinmeyen bir hata oluştu.' }
    }
  },
  cancel: async (form) => {
    try {
      const token = TokenService.getToken()
      const res = await axios.post('https://app.yanibasimdakaratay.com/api/genclik-merkezi-sinema-salonu-cancel', form, {
        headers: {
          Authorization: token,
        },
      })

      return res.data
    } catch (error) {
      // Axios vs. bağlantı hatası
      return { error: 'Bilinmeyen bir hata oluştu.' }
    }
  },
}

export default TicketService
